import { Typography } from '@sravni/react-design-system';

interface IProps {
  className?: string;
}

export const LegalDisclaimer = ({ className }: IProps) => (
  <div className={className}>
    <Typography.Text size={10} className={'h-color-D30'}>
      Представленная информация является субъективным мнением пользователя и не отражает мнение сервиса Сравни
    </Typography.Text>
  </div>
);
